import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/* Blurs its content behind a dark overlay with a message while `message` is set (replaces Semantic Dimmer.Dimmable blurring). */
const DimmedSection: React.FC<{ message?: React.ReactNode }> = ({ message, children }) => (
    <Box sx={{ position: 'relative' }}>
        <Box sx={message ? { filter: 'blur(5px) grayscale(0.7)', pointerEvents: 'none', userSelect: 'none' } : undefined} aria-hidden={!!message}>
            {children}
        </Box>
        {message && (
            <Box
                role="alert"
                sx={{ position: 'absolute', inset: 0, zIndex: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3, backgroundColor: 'rgba(0, 0, 0, 0.85)' }}
            >
                <Typography sx={{ color: '#fff', textAlign: 'center' }}>{message}</Typography>
            </Box>
        )}
    </Box>
);

export default DimmedSection;
